import DOMPurify from 'dompurify';

/**
 * Sanitize an HTML string before injecting it via dangerouslySetInnerHTML.
 *
 * Preserves common rich-text formatting tags and inline styles (needed for
 * template link styling) while stripping scripts, event handlers, and any
 * other executable content that could lead to XSS.
 *
 * Security notes:
 * - target="_blank" links are auto-patched with rel="noopener noreferrer"
 * - style attribute is intentionally allowed for email template fidelity
 *   (CSS injection risk accepted; no user-controlled style input expected)
 */

DOMPurify.removeHook('afterSanitizeAttributes');

// Hook runs once at module load — safe to register globally
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.tagName === 'A' && node.getAttribute('target') === '_blank') {
        node.setAttribute('rel', 'noopener noreferrer');
    }
});

export const sanitizeHtml = (html: string): string =>
    DOMPurify.sanitize(html, {
        ALLOWED_TAGS: [
            'a', 'b', 'strong', 'i', 'em', 'u', 's', 'strike',
            'p', 'br', 'div', 'span', 'blockquote',
            'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
            'ul', 'ol', 'li',
            'table', 'thead', 'tbody', 'tr', 'th', 'td',
            'img',
        ],
        ALLOWED_ATTR: ['href', 'src', 'alt', 'title', 'target', 'rel', 'style', 'class'],
        ALLOW_DATA_ATTR: false,
        FORCE_BODY: true,
});
